(function(){
  if(window.__ruffoVariantAvailabilityLoaded)return;
  window.__ruffoVariantAvailabilityLoaded=true;
  const LOW=2,n=v=>String(v??'').trim().toLowerCase();
  const optName=o=>typeof o==='string'?o:(o?.name||'');
  const isColour=s=>/colou?r|colo/.test(n(s)),isSize=s=>n(s).includes('size');
  const parse=id=>{try{const e=document.getElementById(id);return e?JSON.parse(e.textContent):null}catch(e){console.error('Ruffo variant data error',e);return null}};

  if(!document.getElementById('ruffo-sold-out-selected-style')){
    const style=document.createElement('style');
    style.id='ruffo-sold-out-selected-style';
    style.textContent='.selector-wrapper label.ruffo-sold-out.ruffo-selected-sold-out{opacity:1!important;border-color:#082b3a!important;box-shadow:0 0 0 2px #082b3a!important;background:transparent!important;color:#082b3a!important;cursor:pointer!important;}';
    document.head.appendChild(style);
  }

  function init(section){
    if(!section||section.dataset.ruffoAvailabilityReady)return;
    const id=section.dataset.sectionId,product=parse('ProductJson-'+id);
    if(!id||!product?.variants?.length)return;
    const inventory=parse('RuffoInventoryJson-'+id)||parse('VariantJson-'+id)||[],inv={}; inventory.forEach(v=>inv[String(v.id)]=v);
    const variants=product.variants.map(v=>({...v,...(inv[String(v.id)]||{}),options:[...(v.options||[])]}));
    const names=(product.options||[]).map(optName),colourI=names.findIndex(isColour),sizeI=names.findIndex(isSize);
    const wraps=[...section.querySelectorAll('.selector-wrapper')],master=document.getElementById('ProductSelect-'+id);
    const low=document.getElementById('RuffoLowStock-'+id),lowText=low?.querySelector('.ruffo-low-stock-text');
    const wait=section.querySelector('.js-contact-soldout');
    const cartBtn=document.getElementById('AddToCart-'+id),cartText=document.getElementById('AddToCartText-'+id);
    const initialCartText=cartText?.textContent?.trim()||'';
    const cartAvailableText=/^(sold out|notify me|unavailable)$/i.test(initialCartText)?'Add To Cart':(initialCartText||'Add To Cart');
    const cartOriginalType=cartBtn?.getAttribute('type')||'submit';
    const buyNowBlocks=[...section.querySelectorAll('.product-form__buynow,buy-now')];
    if(!wraps.length||!master)return;
    section.dataset.ruffoAvailabilityReady='true';

    const radios=i=>[...(wraps[i]?.querySelectorAll('input[type="radio"]')||[])],select=i=>wraps[i]?.querySelector('select')||null;
    const selected=i=>{const r=radios(i),c=r.find(x=>x.checked);return c?c.value:(select(i)?.value||null)};
    const values=()=>names.map((_,i)=>selected(i));
    const exact=vals=>variants.find(v=>v.options.length===vals.length&&v.options.every((x,i)=>n(x)===n(vals[i])))||null;
    const current=()=>exact(values())||variants.find(v=>String(v.id)===String(master.value))||null;
    const inputFor=(i,val)=>radios(i).find(r=>n(r.value)===n(val))||select(i);
    const setVal=(i,val)=>{const rs=radios(i);if(rs.length){const r=rs.find(x=>n(x.value)===n(val));if(r){r.disabled=false;r.removeAttribute('disabled');r.checked=true}return r}const s=select(i);if(s)s.value=val;return s};
    const fire=el=>{if(!el){for(let i=names.length-1;i>=0;i--){el=inputFor(i,selected(i));if(el)break}}if(!el)return;window.jQuery?jQuery(el).trigger('change'):el.dispatchEvent(new Event('change',{bubbles:true}))};
    const apply=(v,trigger=true)=>{if(!v)return false;let last=null;v.options.forEach((x,i)=>{if(n(selected(i))!==n(x))last=setVal(i,x)||last});master.value=String(v.id);if(trigger)fire(last);return true};

    function labelFor(w,r){if(!w||!r)return null;try{if(r.id){const l=w.querySelector('label[for="'+CSS.escape(r.id)+'"]');if(l)return l}}catch(e){}return r.closest('label')||(r.nextElementSibling?.tagName==='LABEL'?r.nextElementSibling:null)}
    function targetSize(sizeVal,availableOnly){
      const sel=values();let list=variants.filter(v=>n(v.options[sizeI])===n(sizeVal)&&v.options.every((x,i)=>{
        if(i===sizeI)return true;if(colourI>=0&&i===colourI)return n(x)===n(sel[colourI]);return !sel[i]||n(x)===n(sel[i]);
      }));if(availableOnly)list=list.filter(v=>v.available);return list[0]||null;
    }
    function markSize(val,sold,target){
      const w=wraps[sizeI],rs=radios(sizeI);
      if(rs.length){
        const r=rs.find(x=>n(x.value)===n(val));if(!r)return;const l=labelFor(w,r);
        r.disabled=false;r.removeAttribute('disabled');r.classList.toggle('ruffo-sold-out-input',sold);
        if(sold)r.dataset.ruffoSoldOut='true';else delete r.dataset.ruffoSoldOut;
        r.removeAttribute('aria-disabled');
        if(l){
          l.classList.remove('disabled');l.classList.toggle('ruffo-sold-out',sold);l.classList.toggle('ruffo-selected-sold-out',sold&&r.checked);
          l.removeAttribute('aria-disabled');
          if(sold){
            l.title='Sold out — select to be notified';
            if(target){l.dataset.ruffoNotifyVariantId=String(target.id);l.dataset.ruffoNotifyVariantTitle=target.title||target.options.join(' / ')}
          }else{
            l.removeAttribute('title');delete l.dataset.ruffoNotifyVariantId;delete l.dataset.ruffoNotifyVariantTitle;
          }
        }
      }else{
        const s=select(sizeI);if(s)[...s.options].forEach(o=>{if(n(o.value)===n(val)){o.disabled=false;o.removeAttribute('disabled')}});
      }
    }
    function updateSizes(){if(sizeI<0)return;const rs=radios(sizeI),s=select(sizeI),list=rs.length?rs.map(r=>r.value):(s?[...s.options].map(o=>o.value):[]);list.forEach(val=>markSize(val,!targetSize(val,true),targetSize(val,false)))}
    function availableForColour(colour){
      const sel=values();return variants.find(v=>v.available&&n(v.options[colourI])===n(colour)&&v.options.every((x,i)=>i===colourI||i===sizeI||!sel[i]||n(x)===n(sel[i])))||variants.find(v=>v.available&&n(v.options[colourI])===n(colour))||null;
    }
    function ensureColour(){
      if(colourI<0||sizeI<0)return;const v=exact(values());
      if(v){master.value=String(v.id);return}
      const repl=availableForColour(selected(colourI));if(repl)apply(repl,true);
    }
    function ensureDefault(){
      let urlId=null;try{urlId=new URL(location.href).searchParams.get('variant')}catch(e){}
      const linked=urlId?variants.find(v=>String(v.id)===String(urlId)):null,cur=exact(values());
      const target=linked?.available?linked:(cur?.available?cur:variants.find(v=>v.available));if(target)apply(target,true);
    }
    function lowStock(){if(!low||!lowText)return;const v=current();low.hidden=true;if(!v)return;const q=Number(v.inventory_quantity);if(v.inventory_management&&v.available&&q>0&&q<=LOW){lowText.innerHTML='<strong>Only '+q+' left</strong> in stock';low.hidden=false}}
    function setNotify(v){if(!v)return;const text=product.title+' - '+(v.title||v.options.join(' / ')),inp=document.getElementById('ContactProduct'),span=document.querySelector('#jsSoldout .js-notify-text span');if(inp){inp.value=text;inp.setAttribute('value',text)}if(span)span.textContent=' '+text}
    function waitlist(){const v=current();if(!wait)return;wait.classList.add('hide');if(v&&!v.available)setNotify(v)}
    function buttonState(){
      if(!cartBtn||!cartText)return;const v=current(),sold=!!(v&&!v.available);
      if(sold){
        setNotify(v);cartBtn.disabled=false;cartBtn.removeAttribute('disabled');cartBtn.removeAttribute('aria-disabled');cartBtn.classList.remove('btn--sold-out');
        cartBtn.dataset.ruffoNotify='true';cartBtn.setAttribute('type','button');cartText.textContent='Notify Me';
        buyNowBlocks.forEach(el=>{el.hidden=true});
      }else{
        delete cartBtn.dataset.ruffoNotify;cartBtn.setAttribute('type',cartOriginalType);cartText.textContent=cartAvailableText;
        if(v?.available){cartBtn.disabled=false;cartBtn.removeAttribute('disabled');cartBtn.removeAttribute('aria-disabled');cartBtn.classList.remove('btn--sold-out')}
        buyNowBlocks.forEach(el=>{el.hidden=false});
      }
    }
    function sync(){
      const v=exact(values());if(v)master.value=String(v.id);
      updateSizes();lowStock();waitlist();buttonState();
    }
    function chooseSoldOut(label){
      const v=variants.find(x=>String(x.id)===String(label?.dataset?.ruffoNotifyVariantId));if(!v)return;
      let changed=null;v.options.forEach((x,i)=>{if(n(selected(i))!==n(x))changed=setVal(i,x)||changed});master.value=String(v.id);setNotify(v);
      const sizeInput=sizeI>=0?inputFor(sizeI,v.options[sizeI]):changed;fire(sizeInput||changed);sync();setTimeout(sync,80);setTimeout(sync,220);setTimeout(sync,450);
    }
    function openNotify(v){
      if(v)setNotify(v);
      if(window.jQuery&&jQuery.fn.modal)jQuery('#jsSoldout').modal('show');
      else section.querySelector('.js-contact-soldout [data-target="#jsSoldout"]')?.click();
    }

    section.addEventListener('change',e=>{
      if(!e.target.matches('.selector-wrapper input,.selector-wrapper select'))return;
      const attr=e.target.dataset.index;let i=attr?.startsWith('option')?parseInt(attr.replace('option',''),10)-1:wraps.findIndex(w=>w.contains(e.target));
      if(i===colourI)setTimeout(()=>{ensureColour();sync();setTimeout(sync,90);setTimeout(sync,250);setTimeout(sync,600)},25);
      else{setTimeout(sync,50);setTimeout(sync,180);setTimeout(sync,350);setTimeout(sync,600)}
    });

    window.addEventListener('click',e=>{
      const l=e.target.closest?.('label.ruffo-sold-out');
      if(l&&section.contains(l)){
        e.preventDefault();e.stopPropagation();e.stopImmediatePropagation?.();chooseSoldOut(l);return;
      }
      const b=e.target.closest?.('button');
      if(b===cartBtn&&cartBtn.dataset.ruffoNotify==='true'){
        e.preventDefault();e.stopPropagation();e.stopImmediatePropagation?.();openNotify(current());
      }
    },true);

    window.addEventListener('keydown',e=>{
      if(e.key!=='Enter'&&e.key!==' ')return;
      const r=e.target.closest?.('input.ruffo-sold-out-input');if(!r||!section.contains(r))return;
      const l=labelFor(wraps[sizeI],r);if(!l)return;
      e.preventDefault();e.stopPropagation();e.stopImmediatePropagation?.();chooseSoldOut(l);
    },true);

    ensureDefault();setTimeout(sync,90);setTimeout(sync,350);setTimeout(sync,700);
  }
  const all=()=>document.querySelectorAll('[data-section-type="product"]').forEach(init);
  document.readyState==='loading'?document.addEventListener('DOMContentLoaded',all):all();
  document.addEventListener('shopify:section:load',e=>{const s=e.target.querySelector?.('[data-section-type="product"]');if(s)init(s)});
})();
